import React, {Component} from 'react'
import StyleSheet from 'styles'

export class LinkButton extends Component {
  render = () => {
    const {disabled, ...props} = this.props
    return (
      <button {...props} className={[props.className, styles({root: true, disabled: !!disabled})].filter(c => c).join(' ')}/>
    )
  }
}

const styles = StyleSheet({
  root: {
    border: 'none',
    background: 'transparent',
    color: '#095084',
    display: 'inline',
    appearance: 'none',
    textAlign: 'left',
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontWeight: 'inherit',
    padding: 0,
    margin: 0,
    cursor: 'pointer',
    '&:focus': {
      border: 'none',
      background: 'transparent',
      outline: 'none',
    },
    '&:hover': {
      opacity: 0.8,
      transition: 'opacity 200ms',
      textDecoration: 'underline',
    }
  },
  disabled: {
    textDecoration: 'none',
    color: 'inherit',
    cursor: 'auto',
  }
})